module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-modal",
    class: {
      error: _vm.isError
    },
    attrs: {
      "id": "compartir-modal"
    }
  }, [_c('div', {
    staticClass: "dismiss",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.$t('title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('labelLink')))]), _vm._v(" "), _c('fieldset', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.url),
      expression: "url"
    }],
    staticClass: "form-control my-border",
    attrs: {
      "lang": "ca",
      "id": "nom",
      "name": "nom",
      "type": "text",
      "readonly": "true"
    },
    domProps: {
      "value": (_vm.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.url = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('labelIframe')))]), _vm._v(" "), _c('fieldset', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.iframe),
      expression: "iframe"
    }],
    staticClass: "form-control my-border",
    attrs: {
      "lang": "ca",
      "id": "nom",
      "name": "nom",
      "type": "text",
      "readonly": "true",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.iframe)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.iframe = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br')])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10226cf0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/perfil/components/compartir-modal/compartir-modal.vue
// module id = 287
// module chunks = 0